 <div class="row py-sm">
  <div class="col-6 grey">
    {{key}}
  </div>
  <div class="col-6" [ngClass]="{'left' : alignDirection==='left', 'right' : alignDirection==='right', 'center' : alignDirection==='center'}">
    <ng-content> </ng-content>
  </div>
</div>
